import React, { useState } from 'react';
import {Link, useLocation} from "react-router-dom";
import { languageManager } from '../../utils/i18n';
import LanguageSwitcher from '../LanguageSwitcher';
import './footer.css'
import {useMediaQuery} from "../../hooks";

const Footer = () => {
	const t = key => languageManager.t(key);
	const [showPresent, setShowPresent] = useState(false);
	const [soon, setSoon] = useState(false);

	const location = useLocation();
	const currentPath = location.pathname;
	const mobile = useMediaQuery("(max-width: 768px)");

	const isPastPage = currentPath  === '/past';
	const isNowPage = currentPath  === '/arch' || currentPath  === '/residents' || currentPath  === '/popup';
	const isContactsPage = currentPath  === '/contacts';
	const isArchPage = currentPath  === '/arch';
	const isResidentsPage = currentPath  === '/residents';
	const isPopupPage = currentPath  === '/popup';

	const onFutureClick = () => {
		setSoon(true)
		setTimeout(() =>setSoon(false), 3000);
	}

	return (
		<>
			{!mobile &&
				<footer className="footer">
					<div className="container">
						<div className="footer__inner">
							<nav className="footer__nav">
								<ul className="footer__menu">
									<li className="">
										<Link to="/past" className="footer__link footer__menu-item" style={{backgroundColor: isPastPage ? '#BADDE2' : 'white'}}>
											{t('nav.past')}
										</Link>
									</li>

									<li
										className="footer__menu-item footer__menu-item--dropdown"
										style={{backgroundColor: isNowPage ? '#BADDE2' : 'white'}}
										onMouseEnter={() => setShowPresent(true)}
										onMouseLeave={() => setShowPresent(false)}
									>
                <span className="footer__link">
                  {t('nav.present')}
                </span>

										{showPresent && (
											<ul className="footer__submenu" >
												<li className="footer__submenu-item" style={{backgroundColor: isArchPage ? '#BADDE2' : 'white'}} onClick={() => setShowPresent(false)}>
													<Link to="/arch" className="footer__sublink">
														{t('nav.archaeology')}
													</Link>
												</li>
												<li className="footer__submenu-item" style={{backgroundColor: isResidentsPage ? '#BADDE2' : 'white'}} onClick={() => setShowPresent(false)}>
													<Link to="/residents" className="footer__sublink">
														{t('nav.residents')}
													</Link>
												</li>
												<li className="footer__submenu-item" style={{backgroundColor: isPopupPage ? '#BADDE2' : 'white'}} onClick={() => setShowPresent(false)}>
													<Link to="/popup" className="footer__sublink">
														{t('nav.popup')}
													</Link>
												</li>
											</ul>
										)}
									</li>

									<li className="">
										{/*<Link to="/future" className="footer__link footer__menu-item">*/}
										<div  className="footer__link footer__menu-item" onClick={onFutureClick} style={{backgroundColor: soon ? '#BADDE2' : 'white'}}>
											{soon ?  t('nav.soon') : t('nav.future')}
										</div>
									</li>

									<li className="footer_button__contacts" >
										<Link to="/contacts" className="footer__link footer__menu-item"  style={{backgroundColor: isContactsPage ? '#BADDE2' : 'white'}}>
											{t('nav.contacts')}
										</Link>
									</li>
								</ul>
							</nav>

							<div className="footer__lang">
								<LanguageSwitcher/>
							</div>
						</div>
					</div>
				</footer>
			}
		</>
	);
};

export default Footer;